export function queryRegExpToStr(str: string) {
	return str
		.replace('/^(.*?(', '')
		.replace(')[^$]*)$/i', '')
		.replace(/\\([.*+?^${}()|[\]\\-])/g, '$1')
		.replace(/\|/g, ' ')
}
